const PUNCTUATION_MARKS = [
  ',',
  '?',
  ';',
  ':',
  '!',
  '"',
  '_',
  '\\',
  '@',
  '[',
  ']',
  '*',
  '.',
]

export default PUNCTUATION_MARKS
